import React from 'react'
import { Icon } from '../../../shared/tr-icons'
import { StyledCaret } from './CaretButton.styles'

const CaretButton = (props) => {
  return (
    <StyledCaret tabIndex='0' {...props}>
      <Icon type='caretUp' />
    </StyledCaret>
  )
}

export default CaretButton
